/* eslint-disable no-console */
import LanguageDetector from 'i18next-browser-languagedetector'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import Backend from 'i18next-http-backend'
import store from '@/store'
import { setLanguage } from '@/store/languageSlice'
import { DEFAULT_LANG, getLocalLang } from '../utils'
import { LANGUAGE } from '@/constants'
import './injectFeedbackI18n'

const localLang = getLocalLang()
i18n
  // 请求资源
  .use(Backend)
  // 语言检测插件
  .use(LanguageDetector)
  // react i18n 插件
  .use(initReactI18next)
  // 初始化
  .init({
    load: 'currentOnly', // en-US: - 'all' ⇒ ['en-US', 'en', 'dev'] - 'currentOnly' ⇒ 'en-US' - 'languageOnly' ⇒ 'en'
    backend: {
      loadPath: function (lngs: string[]) {
        const lng = lngs[0]
        const search = `?lng=${lng}&hash=${process.env.GIT_COMMIT_HASH}`
        let url = `/{{lng}}.json`
        switch (lng) {
          case 'zh':
          case 'zh-CN':
            url = `/zh-hans-cn.json`
            break
          case 'zh-TW':
            url = `/zh-hant-tw.json`
            break
        }
        return url + search
      },
      request: async function (options, url, payload, callback) {
        // 判断入口环境，国内则使用oss
        const firstUrl = process.env.REGION === 'oss' ? process.env.I18N_URL_OSS : process.env.I18N_URL_S3
        // 兜底url
        const fallbackUrl = process.env.REGION === 'oss' ? process.env.I18N_URL_S3 : process.env.I18N_URL_OSS

        const _request = async (baseUrl: string) => {
          const data = await fetch(`${baseUrl}${url}`).then((res) => res.json())
          callback(null, {
            status: 200,
            data,
          })
        }

        try {
          await _request(firstUrl)
        } catch (error) {
          // 容灾，请求失败，则换一个cdn源重试
          await _request(fallbackUrl)
        }
      },
    },
    fallbackLng: DEFAULT_LANG,
    // value变量值
    interpolation: {
      // 关闭转移
      escapeValue: false,
    },
    // 使用的语种，会无视掉LanguageDetector插件的detection.order配置
    lng: localLang?.[0]?.lang,
    debug: false,
    // 支持的语言
    supportedLngs: ['en', 'zh', 'zh-TW', 'zh-CN'],
    // key分割的方式
    keySeparator: false,
    // detection: {
    //   order: ['querystring', 'cookie', 'localStorage', 'sessionStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
    // }
  })
  .then(() => {
    const localLang = getLocalLang()
    store.dispatch(setLanguage(localLang[0] || LANGUAGE.find((lang) => lang.lang === DEFAULT_LANG)))
  })

export const noLang = {
  label: '显示多语言key',
  lang: 'nokey',
  languageType: 'nokey' as 'en',
  antd: 'nokey_NO',
}
export const canShowI18nKey = process.env.APP_ENV !== 'product'

/**
 *
 * args[0] === key,
 * 判断不需要显示多语言的时候，直接输出key
 */
if (canShowI18nKey) {
  const t = i18n.t
  i18n.t = (...args) => (i18n.language === noLang.lang ? args[0] : t.call(i18n, ...args))
}

export default i18n
